/**
 * Append `path` to `baseUrl` with exactly one slash between them. The tenant
 * URLs end in a slash (`wss://dev.salesserver.net/standalone/`) and nginx
 * forwards a doubled slash to the service as part of the path, which the
 * service does not route.
 */
export const joinUrlPath = (baseUrl: string, path: string): string =>
  `${baseUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
